import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import './Breadcrumb.css';

export default function Breadcrumb({ crumbs = [], dark = true }) {
    const navigate = useNavigate();

    if (!crumbs.length) return null;

    return (
        <nav
            className={`breadcrumb${dark ? '' : ' breadcrumb--light'}`}
            aria-label="Ruta de navegación"
        >
            <ol className="breadcrumb__list" aria-label="breadcrumb">
                {crumbs.map((crumb, i) => {
                    const isLast = i === crumbs.length - 1;
                    return (
                        <li
                            key={i}
                            className={`breadcrumb__item${isLast ? '' : ' breadcrumb__item--parent'}`}
                        >
                            {!isLast && crumb.to ? (
                                <button
                                    className="breadcrumb__link"
                                    onClick={() => navigate(crumb.to)}
                                >
                                    {crumb.label}
                                </button>
                            ) : (
                                <span
                                    className={`breadcrumb__current${isLast ? '' : ' breadcrumb__current--parent'}`}
                                    aria-current={isLast ? 'page' : undefined}
                                >
                                    {crumb.label}
                                </span>
                            )}
                            {!isLast && (
                                <span className="breadcrumb__sep" aria-hidden="true">›</span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
